import React, { Component } from 'react';
import './App.css';
import Navigation from './Navigation.js'
import Footer from './Footer.js'


class Contact extends Component {
  
  render() {
    return (
        <div>
            <header>
            <img src="/img/hamburger-menu-logo.png" className="logo" alt="Hamburger Menu Generator Logo" />
            <a href="/" className="logo-title">Hamburger Menu Generator</a>
                <nav className="menu">
                    <Navigation />
                </nav>
            </header>
                <div className="section">
                <h1>Contact Us</h1>
                <p>If you have any questions or business inquiries, contact us at <b>contact@hamburgermenugenerator.com</b></p>
                </div>
            <Footer />
         </div>
    );
  }
}

export default Contact;